import { Box, Button, Grid } from '@mui/material'
import React, { createRef, memo, useCallback, useEffect, useMemo, useState } from 'react'
import { TextBoxLatest } from '../common/TextBoxLatest/TextBoxLatest'
import CustomFormLabel from '../common/form-label/CustomFormLabel ';
import CustomSelect from '../common/customSelect/CustomSelect';
import AddCategoryCopy from '../../pages/new-ticket/AddCategoryPopup';
import { useNavigate } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { IState } from '../../redux/reducers/rootReducers';
import CommonStyles from '../common/CommonStyles';
import CategoryTreeSelection from '../../pages/new-ticket/AddCategoryPopup';
import { triggerAppAlert } from '../../redux/actions/SelfServicePortal/ContactAid/ContactAid';
import { handleTime } from '../helpers/helperFunctions';
import configs from '../../configs/config';
import axios from 'axios';
const url = `${configs.BASE_URL}/`;
const GeneralProperties = memo(({ submitHandler,initialVal, categoryList, ticketTypes,type,dispatch }: any)=> {
    const titleRef: any = createRef();
    const descRef: any = createRef();
    const classes= CommonStyles();
    const navigate = useNavigate();
    const [errorObj,setErrorObj] = useState<any>({
        ticketTypeId: false,
        categoryId: false,
        title: false,
        description: false
    })
    const [ticketTypeVal, setTicketTypeVal] = useState<any>(null);
    const [categoryVal, setCategoryVal] = React.useState<any>(null);
    const [ticketTypesOptions,setTicketTypesOptions]= React.useState<any>([]);
    const formRef = React.useRef<HTMLFormElement>(null);
    const handleSubmit = (e: any) => {
        e.preventDefault();
        onSubmit();
        // if (!formRef.current?.reportValidity()) return;
        // submitHandler(
        //     titleRef?.current?.value,
        //     descRef?.current?.value,
        //     ticketTypeVal?.id || null,
        //     categoryVal?.id || null
        // );
    };

    const onCategorySubmit = useCallback((res: any) => {
        // console.log("onCategorySubmit", res, "category");
        setCategoryVal(res)
        unsetError("categoryId")
    }, []);
    const cancelHandler = () => {
           navigate(
              type === "Ticket"?
              "/webFormList"
              : type === "Survey"
              ? "/SurveyTemplates"
              : type === "TicketAdditionalField"
              ? "/TicketAdditionalField"
              : "/");
        }
        function transformData(data: any[]) {
        return data.map((item:any) => ({
            ...item,
            label: item.displayName?.trim() || item.name,
            value: item.id,
        }));
        }
    useEffect(() => {
        if(type === "TicketAdditionalField"){
              axios.get( `${url}webform/unassigned/tickettypes`)
      .then((response: any) => {
        const activeValues = response?.data?.filter((item: any) => item.isActive);
        setTicketTypesOptions(transformData(activeValues))
      })}
       
        if(!initialVal) return;
        // useEffect(() => {
        if(descRef?.current){
            descRef.current.value = initialVal.description || "";
        }
        if(titleRef?.current){
            titleRef.current.value = initialVal.name;
        }
        if(initialVal.ticketType){
            setTicketTypeVal({
                ...initialVal.ticketType,
                label: initialVal.ticketType.displayName,
                value: initialVal.ticketType.displayName,
            })
        }
        if(initialVal.category){
            setCategoryVal({
                ...initialVal.category,
                label: initialVal.category.name
            })
        }
    }, [initialVal])
    const onSubmit = () => {
        let valid = true;
        const tempObj = {
            ticketTypeId: false,
            categoryId: false,
            title: false,
            description : false,
        }
        if (!titleRef?.current?.value ) {
            tempObj.title = titleRef?.current?.value ? false : true;
            valid = false;
        }
        if (type === "Survey" && !descRef?.current?.value ) {
            tempObj.description = descRef?.current?.value ? false : true;
            valid = false;
        }
        if (type !== "Survey" && !ticketTypeVal) {
            tempObj.ticketTypeId = ticketTypeVal ? false : true;
            valid = false;
        }
        if ((type !== "Survey"&& !categoryVal)&& type !== "TicketAdditionalField") {
            tempObj.categoryId = categoryVal ? false : true;
            valid = false;
        }
        setErrorObj(tempObj)
        

        

        if(!valid) return;
        submitHandler(titleRef?.current?.value,descRef?.current?.value, ticketTypeVal?.id || null, categoryVal?.id || null)
    }
    const DescError = useMemo(() => <>
        {errorObj.description && <CustomFormLabel
            labelName={"Please Enter Description"}
            isMandotary={false}
            classNames='sml-txt txt-danger'
        />
    }</>, [errorObj.description]);
    const NameError = useMemo(() => <>
        {errorObj.title && <CustomFormLabel
            labelName={"Please Enter Name"}
            isMandotary={false}
            classNames='sml-txt txt-danger'
        />
    }</>, [errorObj.title]);
    const TicketTypeError = useMemo(() => <>
        {errorObj.ticketTypeId && <CustomFormLabel
            labelName={"Please Select Ticket Type"}
            isMandotary={false}
            classNames='sml-txt txt-danger'
        />
    }</>, [errorObj.ticketTypeId]);
    const CategoryError = useMemo(() => <>
        {errorObj.categoryId && <CustomFormLabel
            labelName={"Please Select Category"}
            isMandotary={false}
            classNames='sml-txt txt-danger'
        />
    }</>, [errorObj.categoryId]);

    
    const unsetError = (key:string) =>{
            handleTime.cancel();
            handleTime.setup(()=>{
                setErrorObj({
                    ...errorObj,
                    [key] : false
                })
            })
    }
    return (<>
        <form ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={3}>
                {type === "Survey" &&
                    <>
                        <Grid item md={4.5} xs={12}>
                            <TextBoxLatest
                                multiline={false}
                                placeholder="Enter Name"
                                title={"Name"}
                                ref={titleRef}
                                isMandotary={true}
                                required={true}
                                isError={errorObj.title}
                                onchangeHandler={() => { unsetError("title") }}
                            />
                            {/* {NameError} */}
                        </Grid>
                        <Grid item md={4.5} xs={12} className='webforms-details'>
                            <TextBoxLatest
                                multiline={false}
                                placeholder="Enter Description"
                                title={"Description"}
                                ref={descRef}
                                isMandotary={true}
                                onchangeHandler={() => { unsetError("description") }}
                            />
                            {DescError}
                        </Grid>
                    </>
                }
                {type === "Ticket" &&
                    <>
                        <Grid item md={3} xs={12}>
                            <TextBoxLatest
                                multiline={false}
                                placeholder="Enter Name"
                                title={"Name"}
                                ref={titleRef}
                                // required={true}
                                isMandotary={true}
                                isError={errorObj.title}
                                onchangeHandler={() => { unsetError("title") }}
                            />
                            {/* {NameError} */}
                        </Grid>
                        <Grid item md={3} xs={12} className='webforms-details' style={{ position: "relative" }}>
                            <CustomFormLabel
                                labelName={"Select Ticket Type"}
                                isMandotary={true}
                            />
                            <CustomSelect
                                isOpen={false}
                                placeholder="Select Ticket Type" 
                                width={"100%"}
                                name="workflowNodeAgentApprovalList"
                                isColor={false}
                                isDisabled={false}
                                // isError={false}
                                isError={errorObj.ticketTypeId}
                                defaultValue={ticketTypeVal}
                                options={ticketTypes || []}
                                handleChange={(e: any) => {
                                    {  }
                                    unsetError("ticketTypeId")
                                    setTicketTypeVal(e)
                                    setCategoryVal(null)
                                }}
                                isMulti={false}
                                helperText={""}
                                customClassNames="Select-TicketType"
                            />
                            {/* <select
                                        required
                                        value={ticketTypeVal?.value || ""}
                                        onChange={() => {}}
                                        tabIndex={-1}
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            opacity: 0,
                                            height: "100%",
                                            width: "100%",
                                            pointerEvents: "none",
                                            zIndex: 1
                                        }}
                                    >
                                        <option value="" disabled hidden></option>
                                        {ticketTypes?.map((item: any) => (
                                            <option key={item.value || item.id} value={item.value || item.id}>
                                                {item.label || item.displayName}
                                            </option>
                                        ))}
                                    </select> */}
                            {TicketTypeError}
                        </Grid>
                        <Grid item md={3} xs={12} className='webforms-subcategory' style={{ position: "relative" }}>
                            <CustomFormLabel
                                labelName={"Select Sub Category"}
                                isMandotary={true}
                            />
                            <Button sx={{height:'54px', fontsize:'14px',borderColor: errorObj.categoryId ? '#ff0000 !important' : '#ccc !important', color: 'inherit', '&:hover': { borderColor: errorObj.categoryId ? '#ff0000' : '#ccc', backgroundColor: 'transparent',},}} className="input-like-btn" onClick={() => { 
                                if(ticketTypeVal?.id){
                                    dispatch({
                                    type:"CATEGORY_POPUP_TICKET_TYPE_ID",
                                    payload : ticketTypeVal?.id
                                    })
                                }else{
                                    dispatch(triggerAppAlert("Please Choose Ticket Type before Selecting Category","warning"))
                                }
                            }}>
                                {categoryVal?.label || ""}
                            </Button>
                            {/* <select
                                required
                                value={categoryVal ? String(categoryVal.id) : ""}
                                onChange={() => {}}
                                tabIndex={-1}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    opacity: 0,
                                    width: "100%",
                                    height: "54px",
                                    pointerEvents: "none",
                                }}
                            >
                                <option value="" disabled hidden></option>
                                {categoryList?.map((item: any) => (
                                    <option key={item.id} value={item.id}>{item.label || item.name}</option>
                                ))}
                            </select> */}
                            {CategoryError}
                        </Grid>
                    </>
                }

                {type === "TicketAdditionalField" &&
                                <>
                                    <Grid item md={3} xs={12}>
                                        <TextBoxLatest
                                            multiline={false}
                                            placeholder="Enter Name"
                                            title={"Name"}
                                            ref={titleRef}
                                            isMandotary={true}
                                            isError={errorObj.title}
                                            onchangeHandler={() => { unsetError("title") }}
                                        />
                                        {/* {NameError} */}
                                    </Grid>
                                    <Grid item md={3} xs={12} className='webforms-details'>
                                        <CustomFormLabel
                                            labelName={"Select Ticket Type"}
                                            isMandotary={true}
                                        />
                                        <CustomSelect
                                            isOpen={false}
                                            placeholder="Select Ticket Type"
                                            width={"100%"}
                                            name="workflowNodeAgentApprovalList"
                                            isColor={false}
                                            isDisabled={false}
                                            // isError={false}
                                            isError={errorObj.ticketTypeId}
                                            defaultValue={ticketTypeVal}
                                            options={ticketTypesOptions || []}
                                            handleChange={(e: any) => {
                                                {  }
                                                unsetError("ticketTypeId")
                                                setTicketTypeVal(e)
                                                setCategoryVal(null)
                                            }}
                                            isMulti={false}
                                            // helperText={""}
                                            // customClassNames=" Select-TicketType"
                                            helperText={errorObj.ticketTypeId ? "Please Select Ticket Type" : ""}
                                            // customClassNames={`Select-TicketType ${errorObj.ticketTypeId ? "error-select" : ""}`}
                                            customClassNames="Select-TicketType"
                                        />
                                        {/* <select
                                        required
                                        value={ticketTypeVal?.value || ""}
                                        onChange={() => {}}
                                        tabIndex={-1}
                                        style={{
                                            position: "absolute",
                                            top: "48px",
                                            left: "10px",
                                            opacity: 0,
                                            height: "1px",
                                            width: "90%",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <option value="" disabled hidden></option>
                                        {ticketTypes?.map((item: any) => (
                                            <option key={item.value || item.id} value={item.value || item.id}>
                                                {item.label || item.displayName}
                                            </option>
                                        ))}
                                    </select> */}
                                        {/* {TicketTypeError} */}
                                    </Grid>
                                
                                </>
                            }
                <Grid item md={3} xs={12} className="text-right">
                    <Box className="text-center" style={{ padding: "10px" }}>
                        <Button className={`${classes.btn} ${classes.btnCancel}`} style={{ width: "100px" }} variant="contained" onClick={cancelHandler}>Cancel</Button> &nbsp; &nbsp;
                        {/* <Button variant="contained" onClick={onSubmit}>Submit</Button> */}
                        <Button type="submit" variant="contained">Submit</Button>
                    </Box>
                </Grid>
            </Grid>
        </form>    
        <CategoryTreeSelection callback={onCategorySubmit}/>
    </>
    )
})

const mapStateToProps = (state:IState) => {
    return ({
      //LoginReducer: state?.LoginReducer?.roleAccess,
        categoryList : state?.categoryReducer?.Data?.data,
        ticketTypes : state?.TicketsReducer?.allResponses?.TicketTypes
    })
  };
  
export default connect(mapStateToProps)(GeneralProperties);